<template>
  <div :class="['tooltip', tooltipClass]">
    <button class="tooltip-link" @click="clickTooltip">
      <slot name="tooltipButtonTemplate"></slot>
    </button>
    <div class="tooltip-bubble">
      <div class="tooltip-bubble-inner bottom-visible">
        <slot name="tooltipBubbleTemplate"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: ['tooltipButtonTemplate', 'tooltipBubbleTemplate', 'tooltipClass'],
  mounted () {
    var _this = this

    // For fixed & hovered

    if (this.$el.classList.contains('tooltip--fixed') && ! this.$el.classList.contains('tooltip--onclick')) {
      this.$el.addEventListener('mouseenter', function(){
        _this.tooltipBubblePlacer()
      })
    }

    // Hide tooltip when we clicked outside

    document.addEventListener('mouseup', function(e){
      var tooltipContainer = _this.$el,
          me = e.target,
          myParents = []
      while (me) {
        myParents.unshift(me)
        me = me.parentNode
      }
      if (tooltipContainer != e.target && ! myParents.includes(tooltipContainer)){
        tooltipContainer.classList.remove('active')
      }
    })
  },
  methods: {
    // For fixed & clickable

    getOffset (element, horizontal = false) {
      if(!element) return 0;
      return this.getOffset(element.offsetParent, horizontal) + (horizontal ? element.offsetLeft : element.offsetTop);
    },

    tooltipBubblePlacer () {
      var myTooltip = this.$el,
          myLeft = this.getOffset(myTooltip, true) + myTooltip.offsetWidth + 21 - myTooltip.querySelector('.tooltip-bubble').offsetWidth,
          myTop,
          supportPageOffset = window.pageXOffset !== undefined,
          isCSS1Compat = ((document.compatMode || "") === "CSS1Compat"),
          scrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
      if (myTooltip.classList.contains('tooltip--bottom')){
        myTop = this.getOffset(myTooltip.querySelector('.tooltip-link')) - scrollTop + myTooltip.querySelector('.tooltip-link').offsetHeight
      } else {
        myTop = this.getOffset(myTooltip.querySelector('.tooltip-link')) - scrollTop - myTooltip.querySelector('.tooltip-bubble').offsetHeight
      }
      myTooltip.querySelector('.tooltip-bubble').style.left = myLeft + 'px'
      myTooltip.querySelector('.tooltip-bubble').style.top = myTop + 'px'
    },

    clickTooltip () {
      var myTooltip = this.$el
      myTooltip.classList.toggle('active')
      if (myTooltip.classList.contains('tooltip--fixed')) {
        this.tooltipBubblePlacer()
      }
    },
  }
}
</script>
